import config from '../../config.json';
import { NavText } from '../../components';
import { AddPhotoIcon, BrushIcon, ErrorIcon, ManIcon, StylusIcon, } from '../../assets/svg';

export const priceTypes = {
  Sketch: {
    element: (
      <>
        <StylusIcon />
        <NavText>Sketch</NavText>
      </>
    ),
    images: [...Array(config.galleryCount['Sketch'])].map((_, ind) => `sketch/${ind + 1}`),
  },
  'Full Render': {
    element: (
      <>
        <BrushIcon />
        <NavText>Full Render</NavText>
      </>
    ),
    images: [...Array(config.galleryCount['Full Render'])].map((_, ind) => `render/${ind + 1}`),
  },
  Background: {
    element: (
      <>
        <AddPhotoIcon />
        <NavText>Background</NavText>
      </>
    ),
    images: [...Array(config.galleryCount['Background'])].map(
      (_, ind) => `background/${ind + 1}`
    ),
  },
  NSFW: {
    element: (
      <>
        <ErrorIcon />
        <NavText>NSFW</NavText>
      </>
    ),
    images: [...Array(config.galleryCount['NSFW'])].map((_, ind) => `nsfw/${ind + 1}`),
  },
  'VTuber Model': {
    element: (
      <>
        <ManIcon />
        <NavText>VTuber</NavText>
      </>
    ),
    images: [...Array(config.galleryCount['VTuber Model'])].map((_, ind) => `vtuber/${ind + 1}`),
  }
};
